<!-- CASHFLOW STEP 4 — Costs & Expenses -->
<div class="cf-page">

  <!-- LEFT PANEL -->
  <div class="panel-left">
    <div class="pl-inner">
      <div class="logo-wrap">
        <a routerLink="/"><img src="assets/Calci_logo (1).png" alt="Adventum Calculators" class="panel-logo-img"></a>
      </div>
      <div class="cf-card">
        <p class="cf-card-pre">Cashflow Calculator</p>
        <h3 class="cf-card-title">Costs &amp; <strong>Expenses</strong></h3>
        <p class="cf-card-sub">Stamp duty is auto-calculated. Enter your recurring and one-off costs.</p>
        <div class="cf-stats">
          <div class="cfs"><div class="cfs-l">Step</div><div class="cfs-v">4 of 4</div></div>
          <div class="cfs acc"><div class="cfs-l">SDLT</div><div class="cfs-v">Auto</div></div>
          <div class="cfs"><div class="cfs-l">Typical Mgmt</div><div class="cfs-v">{{PropertyLondon == 1 ? '12%' : '10%'}}</div></div>
          <div class="cfs acc"><div class="cfs-l">SDLT Amount</div><div class="cfs-v">{{stampDutyLandTax ? '£'+stampDutyLandTax : '—'}}</div></div>
        </div>
      </div>
    </div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="panel-right">
    <div class="pr-inner">

      <!-- Topbar -->
      <div class="topbar">
        <button [routerLink]="['/cashflow/step3']" style="background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center;">
          <img src="/assets/Frame 1000003040.svg" alt="Back" width="44" height="44">
        </button>
        <div class="loc-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          {{calcData?.City || 'United Kingdom'}}
        </div>
      </div>

      <h1 class="step-title">Costs &amp; Expenses</h1>
      <p class="step-sub">Stamp duty is auto-calculated from your property value.</p>

      <!-- UPFRONT COSTS -->
      <div class="sec-label">Upfront Costs (One-Time)</div>

      <!-- Loan Origination Fee -->
      <div class="field" *ngIf="calcData.optmortgage!='0'">
        <div class="field-label">Loan Origination Fee</div>
        <div class="iw">
          <input class="inp" type="text" id="loanOriginationFee" autocomplete="off"
            (keyup)="loanOriginationFee=validation.appendPercent($event,loanOriginationFee)"
            (keypress)="validation.DesimalOnly($event,loanOriginationFee)"
            [(ngModel)]="loanOriginationFee"
            placeholder="e.g. 1">
          <span class="isuf">%</span>
        </div>
        <div class="field-sub">% of loan amount</div>
      </div>

      <!-- SDLT Banner -->
      <div class="sdlt-card" *ngIf="stampDutyLandTax!=''">
        <div class="sdlt-card-left">
          <div class="sdlt-card-name">Stamp Duty &amp; Land Tax</div>
          <div class="sdlt-card-note">{{foreignbuyer==='1' ? '(incl. 2% foreign buyer surcharge)' : 'Standard investment rates · Auto-calculated'}}</div>
        </div>
        <div class="sdlt-card-val">£{{stampDutyLandTax}}</div>
      </div>

      <!-- Hidden SDLT for validation -->
      <input type="hidden" id="stampDutyLandTax" [(ngModel)]="stampDutyLandTax">

      <!-- Foreign Buyer -->
      <div class="field">
        <div class="field-label">Foreign Buyer?</div>
        <div class="toggle-pair">
          <button class="topt" [class.active]="foreignbuyer==='1'" (click)="foreignbuyer='1'; calculatestampduty()">Yes</button>
          <button class="topt" [class.active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'; calculatestampduty()">No</button>
        </div>
      </div>

      <!-- Tax alert -->
      <div class="tax-alert" *ngIf="foreignbuyer==='1'">
        <div class="tax-alert-title">Tax Alert</div>
        <div class="tax-alert-body">Non-UK residents are subject to a 2% SDLT surcharge. This has been factored into your stamp duty estimate.</div>
      </div>

      <!-- ANNUAL RECURRING COSTS -->
      <div class="sec-label">Annual Recurring Costs</div>

      <div class="row3">
        <div class="field" style="margin-bottom:0">
          <div class="field-label">Letting Management</div>
          <div class="iw">
            <input class="inp" type="text" id="letteingManagFee" autocomplete="off"
              (keyup)="letteingManagFee=validation.appendPercent($event,letteingManagFee)"
              (keypress)="validation.DesimalOnly($event,letteingManagFee)"
              [(ngModel)]="letteingManagFee"
              placeholder="e.g. {{PropertyLondon == 1 ? '12' : '10'}}">
            <span class="isuf">%</span>
          </div>
          <div class="field-sub">% of gross rent</div>
        </div>
        <div class="field" style="margin-bottom:0">
          <div class="field-label">Ground Rent p.a.</div>
          <div class="iw">
            <span class="ipre">£</span>
            <input class="inp" type="text" id="groundRent" autocomplete="off"
              [(ngModel)]="groundRent"
              (keyup)="groundRent=validation.amountWithComma(groundRent)"
              (keypress)="validation.numberOnly($event)"
              placeholder="e.g. {{PropertyLondon == 1 ? '500' : '350'}}">
          </div>
        </div>
        <div class="field" style="margin-bottom:0">
          <div class="field-label">Service Charges p.a.</div>
          <div class="iw">
            <span class="ipre">£</span>
            <input class="inp" type="text" id="serviceCharges" autocomplete="off"
              [(ngModel)]="serviceCharges"
              (keyup)="serviceCharges=validation.amountWithComma(serviceCharges)"
              (keypress)="validation.numberOnly($event)"
              placeholder="e.g. {{PropertyLondon == 1 ? '3,000' : '1,000'}}">
          </div>
        </div>
      </div>

      <div class="field">
        <div class="field-label">Other Expenses p.a.</div>
        <div class="iw">
          <span class="ipre">£</span>
          <input class="inp" type="text" id="miscelleneousExpense" autocomplete="off"
            [(ngModel)]="miscelleneousExpense"
            (keyup)="miscelleneousExpense=validation.amountWithComma(miscelleneousExpense)"
            (keypress)="validation.numberOnly($event)"
            placeholder="e.g. 1,000">
        </div>
      </div>

      <!-- Actions -->
      <div class="actions">
        <button class="btn-back" [routerLink]="['/cashflow/step3']">
          <img src="/assets/Frame 1000003040.svg" alt="Back" width="20" height="20">
          Back
        </button>
        <button class="btn-calc" type="button" (click)="next()">Calculate Returns</button>
      </div>

    </div>
  </div>

</div>
